import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonModule, MenuModule } from '@sag-ui';

@Component({
    selector: 'app-table-filter',
    standalone: true,
    imports: [ButtonModule, MenuModule],
    templateUrl: './table-filter.component.html'
})
export class TableFilterComponent {
    @Input() label: string;
    @Input() values: string[];
    @Input() selected: string[];
    @Output() selectionChange: EventEmitter<string[]> = new EventEmitter();

    public select(value: string): void {
        if (this.selected.includes(value)) {
            this.selectionChange.emit(this.selected.filter(v => v !== value));
        } else {
            this.selectionChange.emit([...this.selected, value]);
        }
    }
}
